/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Loadmore1Inputs */

const id_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muat Lebih Banyak`)
};

const ms_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muat Lagi`)
};

const da_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indlæs Mere`)
};

const de_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr laden`)
};

const en_us2_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load More`)
};

const es_es2_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargar más`)
};

const es_mx2_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargar más`)
};

const fil_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-load Pa`)
};

const fr_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charger plus`)
};

const it_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica altro`)
};

const hu_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Több betöltése`)
};

const nl_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meer laden`)
};

const no_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last mer`)
};

const pl_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Załaduj więcej`)
};

const pt_br2_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregar mais`)
};

const pt_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregar mais`)
};

const ro_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Încarcă mai mult`)
};

const fi_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa lisää`)
};

const sv_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladda fler`)
};

const vi_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải thêm`)
};

const tr_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha Fazla Yükle`)
};

const cs_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načíst více`)
};

const bg_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зареждане на още`)
};

const ru_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузить ещё`)
};

const uk_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантажити ще`)
};

const ar_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحميل المزيد`)
};

const hi_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`और लोड करें`)
};

const th_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โหลดเพิ่มเติม`)
};

const ja_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`さらに読み込む`)
};

const zh_cn2_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载更多`)
};

const zh_hant1_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`載入更多`)
};

const ko_tags_loadmore1 = /** @type {(inputs: Tags_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`더 보기`)
};

/**
* | output |
* | --- |
* | "Load More" |
*
* @param {Tags_Loadmore1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const tags_loadmore1 = /** @type {((inputs?: Tags_Loadmore1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Loadmore1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tags_loadmore1(inputs)
	if (locale === "ms") return ms_tags_loadmore1(inputs)
	if (locale === "da") return da_tags_loadmore1(inputs)
	if (locale === "de") return de_tags_loadmore1(inputs)
	if (locale === "en-US") return en_us2_tags_loadmore1(inputs)
	if (locale === "es-ES") return es_es2_tags_loadmore1(inputs)
	if (locale === "es-MX") return es_mx2_tags_loadmore1(inputs)
	if (locale === "fil") return fil_tags_loadmore1(inputs)
	if (locale === "fr") return fr_tags_loadmore1(inputs)
	if (locale === "it") return it_tags_loadmore1(inputs)
	if (locale === "hu") return hu_tags_loadmore1(inputs)
	if (locale === "nl") return nl_tags_loadmore1(inputs)
	if (locale === "no") return no_tags_loadmore1(inputs)
	if (locale === "pl") return pl_tags_loadmore1(inputs)
	if (locale === "pt-BR") return pt_br2_tags_loadmore1(inputs)
	if (locale === "pt") return pt_tags_loadmore1(inputs)
	if (locale === "ro") return ro_tags_loadmore1(inputs)
	if (locale === "fi") return fi_tags_loadmore1(inputs)
	if (locale === "sv") return sv_tags_loadmore1(inputs)
	if (locale === "vi") return vi_tags_loadmore1(inputs)
	if (locale === "tr") return tr_tags_loadmore1(inputs)
	if (locale === "cs") return cs_tags_loadmore1(inputs)
	if (locale === "bg") return bg_tags_loadmore1(inputs)
	if (locale === "ru") return ru_tags_loadmore1(inputs)
	if (locale === "uk") return uk_tags_loadmore1(inputs)
	if (locale === "ar") return ar_tags_loadmore1(inputs)
	if (locale === "hi") return hi_tags_loadmore1(inputs)
	if (locale === "th") return th_tags_loadmore1(inputs)
	if (locale === "ja") return ja_tags_loadmore1(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_loadmore1(inputs)
	if (locale === "zh-Hant") return zh_hant1_tags_loadmore1(inputs)
	return ko_tags_loadmore1(inputs)
});
export { tags_loadmore1 as "tags.loadMore" }